module.exports = "<h3 ng-bind=\"'EMPTY_PAGE' | translate\"></h3>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/utility/empty/empty.html
 ** module id = 254
 ** module chunks = 0
 **/